import $ from 'jquery'

var ScrollListener = function () {}

ScrollListener.prototype.on = function (el, onScroll) {
	if (this.ancestors) {
		this.off()
	}

	this.onScroll = onScroll

	this.ancestors = []
	var parent = $(el)
	do {
		this.ancestors.push(parent)
		parent.scroll(onScroll)
	} while ((parent = parent.parent()).length > 0)
}

ScrollListener.prototype.off = function () {
	if (!this.ancestors) {
		return
	}

	this.ancestors.forEach(function (ancestor) {
		ancestor.off('scroll', this.onScroll)
	}.bind(this))

	delete this.ancestors
	delete this.onScroll
}

export default ScrollListener

ScrollListener.__filename__ = 'components/scroll-listener.js'
